import React from "react";
import { EmailContentProps } from "./types/EmailContent.interface";
import { RFxMailLayout } from "./components/RFxMailLayout";
import { AdditionalMessageDisplay } from "./components/AdditionalMessageDisplay";

export const SubmissionUnsuccessfulEmailContent: React.FC<
	EmailContentProps
> = ({ rfxMail }) => {
	const emailData = rfxMail?.emailData;

	if (!emailData) {
		return null;
	}
	const $owner_company_name = emailData.owner_company_name;
	const $additional_message = emailData.additional_message;
	const type_project = rfxMail.rfx_type_name_project_name();
	const hasAdditionalMessage = !rfxMail.isAdditionalMessageEmpty();

	return (
		<RFxMailLayout
			$supplier_contact_name={emailData.supplier_contact_name}
			$contact={emailData.contact}
			rfx_type={emailData.rfx_code}
			project_name={emailData.project_name}
			rfx_title={emailData.rfx_title}
		>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					Thank you for the time and effort taken to submit a response for the{" "}
					{type_project}.
				</td>
			</tr>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					After careful consideration, we regret to inform you that your
					submission was not selected for this particular project.
				</td>
			</tr>
			{hasAdditionalMessage && (
				<tr>
					<td
						style={{
							fontFamily: "Arial, sans-serif",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#374151",
							paddingBottom: "20px",
						}}
					>
						The reason for this decision is:
						<br />
						<AdditionalMessageDisplay
							additional_message={$additional_message}
							renderRow={false}
						/>
					</td>
				</tr>
			)}

			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					We appreciate your understanding.
				</td>
			</tr>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
					}}
				>
					We value your participation and encourage you to consider future
					opportunities with {$owner_company_name}.
					<br />
					<br />
					Thank you once again for your submission.
				</td>
			</tr>
		</RFxMailLayout>
	);
};
